import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const BinghattiPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    agreement: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };

  const amenities = [
    {
      title: "Branded Luxury Collection",
      description: "Experience the pinnacle of luxury with our exclusive branded residences, featuring world-renowned partnerships with Bugatti, Jacob & Co, and other prestigious brands.",
      image: "/binghatti/bugatti.avif"
    },
    {
      title: "The Ruby Villa",
      description: "A masterpiece of architectural excellence, The Ruby Villa represents the ultimate in luxury living with bespoke design and unparalleled craftsmanship.",
      image: "/binghatti/jacob.avif"
    },
    {
      title: "Burj Binghatti Jacob & Co Residences",
      description: "The world's tallest residential tower featuring exclusive Jacob & Co branded residences, offering unmatched luxury and prestige in the heart of Dubai.",
      image: "/binghatti/mercedes.avif"
    },
    {
      title: "Awards & Recognitions",
      description: "Consistently recognized for excellence in real estate development, Binghatti has received numerous prestigious awards for innovation, design, and quality.",
      image: "/binghatti/Img-1-050824.avif"
    }
  ];

  const featuredProjects = [
    {
      name: "Binghatti Flare",
      location: "Jumeirah Village Triangle, Dubai",
      price: "Premium Collection",
      type: "Luxury Residences",
      image: "/binghatti/binghatti-flare-bedroom-1.webp"
    },
    {
      name: "Binghatti Hillside",
      location: "Dubai Hills Estate, Dubai",
      price: "Elite Collection",
      type: "Premium Villas",
      image: "/binghatti/binghatti-hillside-bedroom-1.webp"
    },
    {
      name: "Binghatti Circle",
      location: "Dubai, UAE",
      price: "Exclusive Collection",
      type: "Luxury Apartments",
      image: "/binghatti/binghatti-circle-bedroom-1.webp"
    }
];

const faqs = [
    {
      question: "What makes Binghatti unique in the real estate market?",
      answer: "Binghatti stands out with its branded luxury collection, featuring exclusive partnerships with world-renowned brands like Bugatti and Jacob & Co, creating truly unique living experiences."
    },
    {
      question: "Where are Binghatti projects located?",
      answer: "Binghatti projects are strategically located across Dubai's most prestigious areas, including Jumeirah Village Triangle, Dubai Hills Estate, and prime locations throughout the city."
    },
    {
      question: "What types of properties does Binghatti offer?",
      answer: "Binghatti offers a diverse portfolio including luxury residences, premium villas, branded collections, and exclusive penthouses, all featuring world-class amenities and finishes."
    }
  ];

  return (
    <div className="flex flex-col min-h-screen font-sans bg-white">
      <Navbar />
      <main className="flex-1">
        {/* Hero Section */}
        <section className="relative w-full h-screen flex flex-col items-center justify-center overflow-hidden">
          <video
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            className="absolute inset-0 w-full h-full object-cover z-0"
            poster="/binghatti/home-video.webp"
            controls={false}
            disablePictureInPicture
            disableRemotePlayback
            onLoadStart={() => console.log('Video loading started')}
            onCanPlay={() => console.log('Video can play')}
            onError={(e) => console.log('Video error:', e)}
          >
            <source src="/binghatti/hero-desktop-edited.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="absolute inset-0 bg-black bg-opacity-40 z-10" />
          <div className="relative z-20 w-full flex flex-col items-center justify-center text-center px-4">
            <h1 className="text-4xl md:text-6xl font-light mb-4 text-white font-sans tracking-tight" style={{fontFamily: 'Roboto, sans-serif'}}>BINGHATTI</h1>
          </div>
        </section>

        {/* Project Overview */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>ABOUT BINGHATTI</h2>
              <p className="text-lg text-gray-600 max-w-4xl mx-auto font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>
                A visionary real estate developer creating exceptional living experiences through innovative design, world-class amenities, and exclusive branded partnerships.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
              <div className="text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Branded Luxury</h3>
                <p className="text-gray-600">Exclusive partnerships</p>
                </div>
              <div className="text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Innovation</h3>
                <p className="text-gray-600">Cutting-edge design</p>
                </div>
              <div className="text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Excellence</h3>
                <p className="text-gray-600">Award-winning quality</p>
              </div>
            </div>
          </div>
        </section>

        {/* The Destination Section */}
        <section className="max-w-6xl mx-auto py-20 px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-6 tracking-tight font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>The Destination</h2>
          </div>
          
          {amenities.map((amenity, index) => (
            <div key={index} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index < amenities.length - 1 ? 'mb-20' : ''}`}>
              {index % 2 === 0 ? (
                // Image Left, Text Right
                <>
                  <div className="relative">
                    <img src={amenity.image} alt={amenity.title} className="w-full h-96 object-cover rounded-lg" />
                  </div>
                  <div className="text-left">
                    <h3 className="text-2xl font-light text-gray-900 mb-4 font-sans tracking-tight" style={{fontFamily: 'Roboto, sans-serif'}}>{amenity.title}</h3>
                    <p className="text-lg text-gray-700 leading-relaxed font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{amenity.description}</p>
                  </div>
                </>
              ) : (
                // Text Left, Image Right
                <>
                  <div className="text-left">
                    <h3 className="text-2xl font-light text-gray-900 mb-4 font-sans tracking-tight" style={{fontFamily: 'Roboto, sans-serif'}}>{amenity.title}</h3>
                    <p className="text-lg text-gray-700 leading-relaxed font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{amenity.description}</p>
                  </div>
                  <div className="relative">
                    <img src={amenity.image} alt={amenity.title} className="w-full h-96 object-cover rounded-lg" />
                  </div>
                </>
              )}
            </div>
          ))}
        </section>

        {/* Featured Projects */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>DISCOVER THE COLLECTION</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {featuredProjects.map((project, index) => (
                <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
                  <div className="h-48 overflow-hidden">
                    <img 
                      src={project.image} 
                      alt={project.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{project.name}</h3>
                    <p className="text-gray-600 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{project.location}</p>
                    {project.price && (
                      <p className="text-green-600 font-semibold mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{project.price}</p>
                    )}
                    {project.type && (
                      <p className="text-gray-500 text-sm mb-4 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{project.type}</p>
                    )}
                    {project.name === 'Binghatti Hillside' ? (
                      <Link 
                        to="/binghatti-hills" 
                        className="inline-block px-6 py-3 bg-black text-white font-medium hover:bg-gray-800 transition-colors duration-200 font-sans" 
                        style={{fontFamily: 'Roboto, sans-serif'}}
                      >
                        EXPLORE
                      </Link>
                    ) : (
                      <Link 
                        to="/contact" 
                        className="inline-block px-6 py-3 bg-black text-white font-medium hover:bg-gray-800 transition-colors duration-200 font-sans" 
                        style={{fontFamily: 'Roboto, sans-serif'}}
                      >
                        EXPLORE
                      </Link>
                    )}
            </div>
            </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>FREQUENTLY ASKED QUESTIONS</h2>
            </div>

          <div className="space-y-6">
            {faqs.map((faq, index) => (
                <div key={index} className="bg-white rounded-lg shadow-md p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{faq.question}</h3>
                  <p className="text-gray-600 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{faq.answer}</p>
              </div>
            ))}
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section className="py-20 bg-white">
          <div className="max-w-4xl mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>EXPRESS YOUR INTEREST</h2>
              <p className="text-lg text-gray-600 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>
                Ready to discover your perfect luxury home with Binghatti? Contact us today.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>Name *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent font-sans"
                    style={{fontFamily: 'Roboto, sans-serif'}}
                  />
                </div>
            <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent font-sans"
                    style={{fontFamily: 'Roboto, sans-serif'}}
                  />
                </div>
            </div>
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>Phone Number</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent font-sans"
                  style={{fontFamily: 'Roboto, sans-serif'}}
                />
            </div>
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>Message</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent font-sans"
                  style={{fontFamily: 'Roboto, sans-serif'}}
                ></textarea>
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  name="agreement"
                  checked={formData.agreement}
                  onChange={handleChange}
                  className="h-4 w-4 text-black focus:ring-black border-gray-300 rounded"
                />
                <label className="ml-2 text-sm text-gray-700 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>
                  I agree to receive exclusive updates & other communications
                </label>
              </div>
              <div className="text-center">
                <button
                  type="submit"
                  className="px-8 py-4 bg-black text-white font-medium hover:bg-gray-800 transition-colors duration-200 font-sans"
                  style={{fontFamily: 'Roboto, sans-serif'}}
                >
                  SUBMIT
                </button>
            </div>
            </form>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default BinghattiPage; 